import {__compiler_private__ as _c} from '@angular/compiler';

export type SelectorMatcher = typeof _c.SelectorMatcher;
export var SelectorMatcher: typeof _c.SelectorMatcher = _c.SelectorMatcher;

export type CssSelector = typeof _c.CssSelector;
export var CssSelector: typeof _c.CssSelector = _c.CssSelector;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
